import { createAction } from '@reduxjs/toolkit'

const CONFIG_ACTION = "Config/";

export const SetConfig = createAction(`${CONFIG_ACTION}SetConfig` );
